<app-apps-banner></app-apps-banner>

<section class="mt-5 inco-terms">
  <div class="container">
    <div class="row pb-80">
      <div class="col-lg-8 pe-4 border-right sm-border-none">
        <div class="border-bottom pb-3 d-md-none d-block">
          <!-- <p class="back-link">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->

        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>

        <div class="d-flex">
          <img src="../assets/images/icons/inco-terms.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
          <h2>The latest International Commerce Terms as published By the ICCy</h2>
        </div>
      </div>

      <div class="d-md-flex align-items-md-center border-bottom pb-3 d-none d-md-flex">
        <img src="../assets/images/icons/inco-terms.png" class="card-img-top img-fluid app-img me-4" alt="Container Specification">
        <div>
          <!-- <p class="back-link mb-0">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </p> -->

        <a class="back-link linked" routerLink="/apps">
          <i class="fa fa-angle-left pe-1" aria-hidden="true"></i> Back to all apps
        </a>


        <h2>The latest International Commerce Terms as published By the ICC</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <form class="apps-form-input d-lg-flex align-items-lg-center">
          <div class="form-group d-md-flex align-items-md-center mb-0 w-100">
            <label for="exampleFormControlSelect1" class="text-white w-100">INCO Term Definitions</label>
            <select class="form-select" [ngModelOptions]="{standalone: true}" [(ngModel)]="INCOSelectedListItem" (ngModelChange)="onINCOChange()" id="exampleFormControlSelect1">
              <option value="deafult">Select INCO Term</option>
              @for (item of INCOList; track item) {
                <option [value]="item.iIncotermID">{{item.cCode}}-{{item.cTerm}}</option>
              }
            </select>
          </div>
        </form>
      </div>
    </div>

    <hr class="main-divider">

    @if (INCOListDestailsBody && INCOListDestailsBody.length > 0) {
      <div class="incotermDetails bg-gray  p-3 mt-3">
        @if (isLoader) {
          <div class="loader">
            <div class="loader-icon">
              <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        }
        <p class="pb-2 res-mb-0"><strong>INCO Term</strong></p>
        <div class="d-flex align-items-center res-hor-scroll">
          <div class="box-shape">
            <img src="../assets/images/apps/inco/seller.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Seller</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/carrier.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Carrier</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/border.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Border</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/port.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Port</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/ship.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Ship</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/port.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Port</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/named-place.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Named Place</p>
          </div>
          <div class="box-shape">
            <img src="../assets/images/apps/inco/buyer.png" alt="noun_top_seller" class="img-fluid">
            <p class="mb-0">Buyer</p>
          </div>
        </div>
        <hr class="inco-terms-divider">
        <div class="fcl-progress-bar">
          <p class="mb-2"><strong>{{INCOListDestailsheader.cCode}}</strong></p>
          <div class="progress">
            <div class="progress-bar progress-bar-1" [ngStyle]="{ 'width': pro1Width }"></div>
            <div class="progress-bar progress-bar-2"></div>
          </div>
        </div>
        <div class="free-carrier-progress-bar pt-4">
          <p class="mb-2"><strong>{{INCOListDestailsheader.cTerm}}</strong></p>
          <div class="progress">
            <div class="progress-bar progress-bar-1" [ngStyle]="{ 'width':  pro2Width  }"></div>
            <div class="progress-bar progress-bar-2"></div>
          </div>
        </div>
        @if (INCOListDestailsheader.cCode == 'CIF') {
          <div class="col-md-10 plr-0 pt-4">
            <div class="in-rows-right">
              <div class="ic-line black"><span class="level three step1">Recommended</span>
              <span class="level three step4">Recommended</span></div>
            </div>
          </div>
        }
        <div class="chart-unit mt-4">
          <div class="row">
            <div class="col-lg-6">
              <div class="cell d-flex align-items-center">
                <span class="color red"></span> The cost is borne by the seller
              </div>
            </div>
            <div class="col-lg-6">
              <div class="cell d-flex align-items-center">
                <span class="color blue"></span> The costs are borne by the seller
              </div>
            </div>
            <div class="col-lg-6">
              <div class="cell last d-flex align-items-center">
                <span class="color black"></span> Transport insurance is the responsibility of the seller
              </div>
            </div>
            <div class="col-lg-6">
              <div class="cell d-flex align-items-center">
                <span class="color red-light"></span> The risk is borne by the seller
              </div>
            </div>
            <div class="col-lg-6">
              <div class="cell d-flex align-items-center">
                <span class="color blue-light"></span> The risk is borne by the seller
              </div>
            </div>
          </div>
        </div>
        <div class="cnt-us mt-4">
          <div class="d-md-flex align-items-md-center justify-content-md-between res-text-center">
            <p class="mb-0"><strong>To know more or talk to our experts please</strong></p>
            <button class="btn" (click)="navigate('contact')">CONTACT US</button>
          </div>
        </div>
        <div class="mt-4">
          <h5 class="card-title">About {{INCOListDestailsheader.cTerm}}</h5>
          <p class="card-text">{{INCOListDestailsheader.cDescription}}</p>
          <table class="table table-bordered mt-4">
            <thead>
              <tr>
                <th scope="col">Services</th>
                <th scope="col">Named Place of delivery</th>
              </tr>
            </thead>
            <tbody>
              @for (item of INCOListDestailsBody; track item) {
                <tr>
                  <td>{{item.cServicedescription}}</td>
                  @if (item.cResponsible==='Buyer') {
                    <td [ngClass]="{'text-danger':item.cResponsible==='Buyer'}">{{item.cResponsible}}</td>
                  }
                  @if (item.cResponsible==='Seller') {
                    <td [ngClass]="{'text-success':item.cResponsible==='Seller'}">{{item.cResponsible}}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>

  <div class="col-lg-4 ps-md-4 ps-xl-5 pe-lg-0">
    <app-other-apps [menu]="'inco'"></app-other-apps>
  </div>

</div>

</div>
</section>

<app-sat></app-sat>